import { DatePickerModeEnum } from './date-picker.enum'

export const getDatePickerClassNameByEnum = (
  datePickerMode: DatePickerModeEnum,
): string => {
  switch (datePickerMode) {
    case DatePickerModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
